import { ModalWindow } from './../../constants/actionType';
import * as saveAction from './save';
import { populateVZDLoverlayName, updatecartEvent } from './../../service/change/vzdl';
import { updateSCTagsmodalWindow, updateSCcustomEvent, tempSCData } from './../../service/change/dtmTag';

export const openModalWindow = (modalId, dispatch) => {
    if (modalId.indexOf("DETAIL") < -1 || modalId.indexOf('BHRX') < -1) {
        updatecartEvent("pageViewOmni");
        updateSCTagsmodalWindow(modalId);
    }
    dispatch({ type: ModalWindow.onModalWindowOpen, value: modalId });
    if (modalId === ModalWindow.ids.yourCart) {
        dispatch({ type: ModalWindow.onCartModalWindowOpen, value: modalId });
    }
    //populateVZDLoverlayName(modalId);
    if (modalId == "COMPAREPRICE") {     
        setTimeout(()=>{
            populateVZDLoverlayName(modalId);
            updatecartEvent("pageViewOmni");
        },1000);           
        updateSCTagsmodalWindow(modalId);
        tempSCData.detailPageName = "ec| services overview| compare price";                
        updateSCcustomEvent("CUSTOMROUTER", "ddAddToCartEvent", "detailPageName");
    }
};

export const closeModalWindow = (modalId, dispatch) => {
    dispatch({ type: ModalWindow.onModalWindowClose, value: modalId });
    if (modalId === ModalWindow.ids.yourCart) {
        dispatch({ type: ModalWindow.onCartModalWindowClose, value: modalId });
    }
    if (modalId === "SAVE") {
        saveAction.saveInvoked(false, dispatch);
    }
};
